import { useColumns } from 'data/tableData/catalogue/sizeScalesColumns';

import { FileInput } from 'components/FileInput';
import { Table } from 'components/Table';

import { useSizeScales } from './SizeScales.hooks';
import * as S from './SizeScales.styles';
import { ImportPreview } from './components/ImportPreview';

export function SizeScales(): React.ReactElement {
  const { isAdmin, scales, isLoading, preview, isBusy, onFileChange, apply, cancel } =
    useSizeScales();
  const columns = useColumns(scales);

  if (!isAdmin) {
    return <S.Message>Only administrators can view and import the size scales.</S.Message>;
  }

  return (
    <div>
      <S.Toolbar>
        <S.Hint>
          Import an XLSX with the &quot;Export Stealth&quot; sheet (Codice | Indice | Codice |
          Taglia): a scale shows its sizes in Indice order, and placeholder rows
          (&quot;.&quot;, &quot;..&quot;) are skipped. A size the file no longer gives is
          deactivated, never deleted: order lines that hold it keep it (struck through here)
          and can only set it to 0. You will see the changes, and the order lines they touch,
          before applying them.
        </S.Hint>

        <FileInput label="IMPORT" accept=".xlsx" disabled={isBusy} onChange={onFileChange} />
      </S.Toolbar>

      <S.ScalesTable>
        <Table tableName="sizeScales" columns={columns} data={scales} isLoading={isLoading} />
      </S.ScalesTable>

      {preview ? (
        <ImportPreview
          fileName={preview.file.name}
          diff={preview.diff}
          isApplying={isBusy}
          onApply={apply}
          onCancel={cancel}
        />
      ) : null}
    </div>
  );
}
